var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "list-Dialog",
          attrs: {
            title: "优惠劵",
            visible: _vm.visible,
            width: "896px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("coupon-list", {
                attrs: {
                  handle: _vm.handle,
                  userIds: _vm.userIds,
                  couponData: _vm.coupons,
                  keyNum: _vm.keyNum,
                  userType: _vm.userType,
                },
                on: {
                  getCouponId: _vm.getCouponId,
                  closeDialog: _vm.closeDialog,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }